import store from '@/store'
import transverser from '@/helpers/transverser'
import auth from '@/auth'
import sso from '@/auth/sso'
import config from '@/utils/config'
import { createAuthRequestNew, isAuthenticated, isExternalyAuthenticated } from '@/auth/token'

/**
 * Returns whether is public route
 * @param {*} route  Current route
 * @return {Boolean} true is route is flag as public, false in other case
 */
const isPublicRoute = (route = {}) =>
  transverser.get('meta.isPublic', false)(route)

/**
 * Check if route is restricted to specific profiles
 */
const isRestrictedToProfiles = (route) => {
  const restrictToProfiles = transverser.get('meta.restrictToProfiles', [])(route)
  if (!restrictToProfiles || restrictToProfiles.length === 0) return false
  const currentProfile = process.env.PROFILE
  return currentProfile && !restrictToProfiles.includes(currentProfile)
}

/**
 * Solo tiene login a través del API de Login
 */
export default (to, from, next) => {
  if (isRestrictedToProfiles(to)) return next({ path: '/' })
  if (isPublicRoute(to)) return next()
  if (isExternalyAuthenticated(to.params.token)) return next()

  if (isAuthenticated()) {
    // Es un fix para el portal de soporte
    if (to.path && (to.path === '/login' || to.path === '/eurobits/login')) {
      return next({ name: 'login' })
    } else {
      return next()
    }
  }

  // Espera el token SSO que debe llegar por postMessage antes de redirigir al login
  if (sso.isPending()) {
    return sso.waitForToken()
      .then(() => next({ path: config.homePath }))
      .catch(() => next({ name: 'login' }))
  }

  // TODO: Quitar y implementar esta logica en el componente del login y a partir del servicio correcto.
  // Esta implementación solo tiene sentido para bankia.
  let authorizationBody = createAuthRequestNew(to.params)

  if (!authorizationBody) return next({ name: 'login' })

  auth.authenticateNew(authorizationBody)
  .then(() => {
    store.dispatch('errors/empty')
    return next()
  }, () => {
    return next({
      name: 'login'
    })
  })
}
